"use client";

export default function OperationalExcellenceTrustBar() {
  const stamps = [{
    label: "Direct from Manufacturer",
    image: "https://outgoing-hookworm.10web.cloud/wp-content/uploads/2026/07/01-direct-from-manufacturer.png?v=trjz3dreut"
  }, {
    label: "CE Certified Products",
    image: "https://outgoing-hookworm.10web.cloud/wp-content/uploads/2026/07/02-ce-certified.png?v=1oybyn0gywc"
  }, {
    label: "Fast Delivery",
    image: "https://outgoing-hookworm.10web.cloud/wp-content/uploads/2026/07/03-fast-delivery.png?v=s4xsohu5fi"
  }, {
    label: "Balkans & Europe Coverage",
    image: "https://outgoing-hookworm.10web.cloud/wp-content/uploads/2026/07/04-balkans-europe-coverage.png?v=uh56yqbi3fb"
  }, {
    label: "B2B & B2C Service",
    image: "https://outgoing-hookworm.10web.cloud/wp-content/uploads/2026/07/05-b2b-b2c-service.png?v=exe9qlk7mv"
  }, {
    label: "Competitive Pricing",
    image: "https://outgoing-hookworm.10web.cloud/wp-content/uploads/2026/07/06-competitive-pricing.png?v=jbso016erl"
  }];
  const loopStamps = [...stamps, ...stamps];
  return <section data-section-id="1391" id="operational-excellence-trust-bar" className="bg-background text-foreground relative overflow-hidden border-t border-b border-border">
      <div className="absolute top-4 left-4 md:top-6 md:left-8 font-mono text-[0.7rem] tracking-[0.1em] text-muted-foreground/70 z-10">
        43°14′N / 21°55′E
      </div>
      <div className="absolute bottom-8 right-4 md:bottom-10 md:right-8 font-mono text-[0.7rem] tracking-[0.1em] text-muted-foreground/70 z-10">
        46°48′N / 8°13′E
      </div>

      <div className="py-16 md:py-20 px-6 md:px-10">
        <div className="max-w-7xl mx-auto text-center">
          <p className="font-default text-[0.8125rem] tracking-[0.18em] text-primary uppercase">
            § Nº 01 — Operational Excellence Standards
          </p>

          <div className="mt-5 mb-8 flex items-center justify-center gap-0">
            <div className="h-px w-32 md:w-48 bg-border" />
            <div className="h-2 w-2 rounded-lg bg-primary" />
          </div>

          <p className="font-default italic text-foreground text-lg md:text-2xl leading-relaxed max-w-3xl mx-auto">
            Engineered for durability, sourced for performance, and delivered with precision.
          </p>
        </div>

        <div className="mt-12 md:mt-16 relative">
          <div className="pointer-events-none absolute left-0 top-0 bottom-0 w-16 md:w-32 z-10" style={{
          background: "linear-gradient(to right, var(--background) 0%, transparent 100%)"
        }} />
          <div className="pointer-events-none absolute right-0 top-0 bottom-0 w-16 md:w-32 z-10" style={{
          background: "linear-gradient(to left, var(--background) 0%, transparent 100%)"
        }} />

          <div className="press-marquee-track flex items-center gap-14 md:gap-14 w-max">
            {loopStamps.map((stamp, i) => {
            return <div key={i} data-index={i} className="press-stamp-item flex items-center gap-14 md:gap-14 shrink-0">
                  <div className="press-stamp group flex flex-col items-center justify-center gap-3 shrink-0" style={{
                width: "120px"
              }}>
                    <div className="flex items-center justify-center w-[72px] h-[72px] border border-primary rounded-lg relative overflow-hidden">
                      <img src={stamp.image} alt={stamp.label} className="size-10 object-contain relative z-10" loading="lazy" decoding="async" />
                    </div>
                    
                    <p className="text-center text-[0.7rem] font-mono uppercase tracking-wider leading-tight text-foreground font-medium">
                      {stamp.label}
                    </p>
                  </div>

                  <div className="flex items-center gap-2 shrink-0">
                    <span className="h-1 w-1 bg-primary/70" />
                    <span className="h-1 w-1 bg-primary/40" />
                    <span className="h-1 w-1 bg-primary/70" />
                  </div>
                </div>;
          })}
          </div>
        </div>
      </div>

      <div className="h-4 w-full" style={{
      backgroundImage: "linear-gradient(to right, var(--primary) 0, var(--primary) 4px, transparent 4px, transparent 10px)",
      backgroundSize: "10px 2px",
      backgroundRepeat: "repeat-x",
      backgroundPosition: "center"
    }} />

      <style>{`
        @keyframes pressMarqueeScroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .press-marquee-track {
          animation: pressMarqueeScroll 40s linear infinite;
        }
        .press-marquee-track:hover {
          animation-play-state: paused;
        }
        .press-stamp {
          transition: transform 700ms cubic-bezier(0.65, 0, 0.35, 1);
        }
        .press-stamp:hover {
          transform: translateY(-4px);
        }
      `}</style>
    </section>;
}